import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mbs-adjust-table-columns',
  templateUrl: './adjust-table-columns.component.html'
})
export class AdjustTableColumnsComponent {
  @Input() existHiddenColumns = false;
  @Input() currentColumnNames: string[];
  @Input() isCheckboxReadonly: boolean;
  @Input() columnsForShow: { [key: string]: { label: string; show: boolean } };

  @Output() editColumnButtonClick = new EventEmitter<boolean>();
  @Output() columnForShowChanged = new EventEmitter<{ checked: boolean, name: string }>();

  public readonly elementsSelector = {
    name: {
      hasUpdateDot: 'hasUpdateDot',
      showColumnsButton: 'showColumnsButton',
      showColumnCheckbox: 'showColumnCheckbox'
    }
  };

  isDotShown() {
    return Object.keys(this.columnsForShow).some((key) => !this.columnsForShow[key].show)
  }
}
